<template>
    <Dialog :dialog="dlg" >
        <v-form ref="form" lazy-validation>
            <Form>
                <FormRow label="Medewerker(s)">            
                    <EmployeesCombo :rules="model.rules.mandatory" :model="model" v-model="model.id_employees"></EmployeesCombo>
                </FormRow>
                <FormRow label="Datum">            
                    <v-row dense>
                        <v-col>
                            <DatePicker :model="model" v-model='model.dt' :rules="model.rules.mandatory"></DatePicker>
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>
                </FormRow>
                <FormRow label="Van/tot">            
                    <v-row dense>
                        <v-col>
                            <v-row dense>
                                <v-col>
                                    <TimeField hm block dusk="from" v-model='model.from' :model='model' :rules="model.rules.mandatory"></TimeField>
                                </v-col>
                                <v-col>
                                    <TimeField hm block dusk="to" v-model='model.to' :model='model' :rules="model.rules.mandatory"></TimeField>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col></v-col>
                    </v-row>
                </FormRow>
             </Form>
        </v-form>    
    </Dialog>
</template>



<script setup>
    import useModel from '@/features/workorders/workorder/model/appointmentcreate'
    import Form from '@controls/forms/Form'
    import FormRow from '@controls/forms/FormRow'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import { ref, computed } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import EmployeesCombo from '@controls/combo/Employees'
    import DatePicker from '@controls/input/DatePicker'
    import TimeField from '@controls/input/TimeField'

    const form = ref(null);

    let model = useModel();
    let dlg = ref(
        new clsDialog("workorder_createappointment", "Maak afspraak", model, [form], {
            showNote: false,
            showAttachment: false,
            icon: 'calendar',
            noSubTitle: true,
            save: 'voeg afspraak toe',
        } )).value;

</script>
